/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    arrayOf,
    bool,
    func,
    number,
    object,
    shape,
    string,
} from 'prop-types';
import { withRouter } from 'react-router';
import { Collapse, Paper } from '@material-ui/core';
import GraphqlProductFacetsV2 from './GraphqlProductFacetsV2';

const GraphqlDesktopProductFacetsV2 = ({
    isFoodBrand,
    classes,
    productFacetsBase,
    isFacetFiltersCountEnabled,
    category,
    trackEventAction,
    setFacetsDataInCollection,
    svgIconData,
    filterDialogData,
}) => {
    // use for showing filter based on toggle
    const [toggleFilter, settoggleFilter] = useState(false);
    return (
        <>
            <div className={!isFoodBrand ? `${classes.mainFilterContainer} ${classes.flowerSortV2Container}` : classes.mainFilterContainer}>
                {isFoodBrand && (
                    <div className={classes.fliterFactsV2}>
                        <span data-testid="show-filterData" role="presentation" onClick={() => settoggleFilter(!toggleFilter)}>
                            {svgIconData(classes, toggleFilter)}
                        </span>
                    </div>
                )}
                {toggleFilter && isFoodBrand && <span className={classes.filterCategoryName}>{category?.name}</span>}
                <div className={classes.breadcrumbAndFilterContainer}>
                    {filterDialogData()}
                </div>
            </div>
            {isFoodBrand && (
                <Collapse in={toggleFilter} className={classes.collapsedContainer}>
                    <Paper className={classes.filterContainerDialogFoodBox} elevation={4}>
                        {productFacetsBase?.length > 0 && (
                            <GraphqlProductFacetsV2
                                category={category}
                                productFacets={productFacetsBase}
                                setFilterDataInCategoryBuilder={setFacetsDataInCollection}
                                isFoodBrand={isFoodBrand}
                                isFacetFiltersCountEnabled={isFacetFiltersCountEnabled}
                                track={trackEventAction}
                                filterOn="Search"
                            />
                        )}
                    </Paper>
                </Collapse>
            )}
        </>
    );
};

GraphqlDesktopProductFacetsV2.propTypes = {
    classes: object.isRequired,
    isFoodBrand: bool.isRequired,
    productFacetsBase: arrayOf(shape({
        name: string,
        entries: arrayOf(shape({
            count: number,
            from: number,
            name: string,
            value: string,
        })),
    })),
    isFacetFiltersCountEnabled: bool.isRequired,
    category: shape({
        id: string,
        name: string,
        productFacets: arrayOf(shape({
            name: string,
            entries: arrayOf(shape({
                count: number,
                from: number,
                name: string,
                value: string,
            })),
        })),
    }),
    trackEventAction: func,
    setFacetsDataInCollection: func.isRequired,
    svgIconData: func.isRequired,
    filterDialogData: func,
};

GraphqlDesktopProductFacetsV2.defaultProps = {
    productFacetsBase: [],
    category: {},
    trackEventAction: () => {},
    filterDialogData: () => {},
};
export default withRouter(GraphqlDesktopProductFacetsV2);
